<!-- Default view -->
<div class="bc-root full-scale">
  <router-outlet></router-outlet>
</div>
